import createAssigner from "./_createAssigner.js";
import allKeys from "./allKeys.js";
export default createAssigner(allKeys);
